export type ICleanEmptyArrayElms = (array: any[]) => any[];

export function cleanEmptyArrayElms(array: any[]): any[] {
  const { length } = array;
  let x = 1;
  for (; x < length; x += 1) {
    if (array[x] === undefined) {
      array.splice(x, 1);
      x -= 1;
    }
  }
  return array;
}
